import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('@superpagos/mf-credits');